import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['query', 'item']

  filter() {
    const query = this.queryTarget.value.trim().toLowerCase()

    this.itemTargets.forEach(item => {
      item.hidden = query !== '' && !item.dataset.name.includes(query)
    })
  }
}
